<template>
    <div class="homepage__equations-solved">
        <img
            loading="lazy"
            class="math-signs math-signs--left"
            :src="iconSignsLeft"
            alt="math-signs"
        />
        <div class="text">
            <div class="left">
                <div class="number-of-equations">
                    {{ solvedTasks }}
                </div>
                <p class="description">
                    {{ $t('lp.equationsSolved.description') }}
                </p>
            </div>

            <div class="right">
                <div class="number-of-equations">106</div>
                <p class="description">
                    {{ $t('lp.equationsSolved.countriesUsing') }}
                </p>
            </div>
        </div>
        <img
            loading="lazy"
            class="math-signs math-signs--right"
            :src="iconSignsRight"
            alt="math-signs"
        />
    </div>
</template>

<script>
import Api from '@/core/services/Api';
import { mapGetters } from 'vuex';
import iconSignsLeft from '@/assets/lp/lp-signs-left.png';
import iconSignsRight from '@/assets/lp/lp-signs-right.png';

export default {
    data() {
        return {
            solvedTasks: 0,
            iconSignsLeft,
            iconSignsRight,
        };
    },
    computed: {
        ...mapGetters({
            locale: 'getCurrentLanguage',
        }),
    },
    created() {
        if (localStorage.getItem('guestToken')) {
            this.fetchTaskCounterInfo();
        } else {
            this.$emitter.on('guestJwtAcquired', this.fetchTaskCounterInfo);
        }
    },
    methods: {
        async fetchTaskCounterInfo() {
            try {
                const response = await Api().get('/task-counter');

                const { success, data } = response.data;

                if (success) {
                    this.solvedTasks = (
                        Math.ceil(data.solvedTasks / 1000000) * 1000000
                    ).toLocaleString(this.locale);
                }
            } catch (e) {
                console.error('fTCI request error: ' + e);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.homepage__equations-solved {
    background-color: #ffc75a;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0.5rem 3rem;
    position: relative;
    z-index: 10;

    @include mq($w-min-wide-desktop, min) {
        margin-top: -5rem;
        padding: 0 0 1rem;
    }

    &::before {
        content: '';
        display: block;
        width: 100%;
        background-color: #ffc75a;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(4deg);
        top: -50px;
        height: 100px;

        @include mq($w-min-md, min) {
            height: 100px;
            transform: skewY(2deg);
            top: -50px;
        }
    }

    &::after {
        content: '';
        display: block;
        width: 100%;
        background-color: #ffc75a;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(-4deg);
        bottom: -20px;
        height: 40px;

        @include mq($w-min-tablet, min) {
            height: 60px;
            bottom: -30px;
        }

        @include mq($w-min-desktop, min) {
            transform: skewY(-2deg);
            bottom: -25px;
        }

        @include mq($w-min-wide-desktop, min) {
            height: 100px;
            bottom: -35px;
        }
    }

    .math-signs {
        width: 20%;
        z-index: 10;

        @include mq($w-min-desktop, min) {
            width: 10%;
        }

        &--right {
            padding-right: 1.5rem;
        }
    }

    .text {
        width: 80%;
        display: inline-block;
        z-index: 4;

        @include mq($w-min-desktop, min) {
            display: flex;
        }

        .left {
            display: inline-block;
            margin-bottom: 1.5rem;

            @include mq($w-min-desktop, min) {
                margin-right: auto;
                margin-left: 20%;
                margin-bottom: 0;
            }
        }

        .right {
            display: inline-block;

            @include mq($w-min-desktop, min) {
                margin-right: 20%;
                margin-left: auto;
            }
        }

        .number-of-equations,
        .description {
            color: #483818;
        }

        .number-of-equations {
            font-weight: bolder;
            font-size: 1.625rem;
            line-height: 2rem;
            text-align: center;

            @include mq($w-min-tablet, min) {
                font-size: 3rem;
                line-height: 3.6875rem;
            }
        }

        .description {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 25px;
            text-align: center;
            margin: 0.5rem 0 0;

            @include mq($w-min-tablet, min) {
                font-size: 1.5rem;
                line-height: 2.0625rem;
                width: 300px;
            }
        }
    }
}
</style>
